import styled, { css } from "styled-components";
import { transparentize } from "polished";
import { ILegendStyleProps } from "./interfaces";

export const TableScroller = styled.div`
    overflow: auto;
    padding: 0 20px;
`;

export const Table = styled.table`
    margin: auto;
    margin-top: 6px;
    padding: 6px;
    border-collapse: separate;
    border-spacing: 0;
    line-height: 28px;
    td {
        padding: 6px 12px;
        text-align: left;
    }

    td.gave-up-cell {
        background-color: ${p => transparentize(0.9, p.theme.c.incorrect)};
    }

    td.first-column {
        text-align: left;
    }
    td.first-value {
        border-left: solid 2px black;
    }

    td.with-task-type {
        border-bottom: solid 2px black;
    }

    tbody tr td:last-child {
        min-width: 60px;
    }

    tbody tr:last-of-type {
        td:not(:first-of-type):not(.first-column):not(.date-column) {
            border-bottom: solid black 2px;
        }
    }

    thead {
        margin-bottom: -1px;
    }

    tbody tr:nth-child(odd) {
        background-color: ${p => transparentize(0.8, p.theme.c.active)};
    }

    /* stylelint-disable */
    td:first-of-type {
        min-width: 120px;
    }
    &.Simulation td:first-of-type {
        max-width: 50px;
        min-width: 50px;
    }
    /* stylelint-enable */

    /* stylelint-disable */

    tbody td:not(.first-value):not(.first-column):not(.date-column) {
        border-left: dashed 1px black;
    }
    tbody td {
        position: relative;
    }
    tbody td:last-of-type {
        border-right: solid 2px black;
        border-left: solid 2px black !important;
    }

    td.date-column {
        font-weight: 300;
    }
    /* stylelint-enable */

    .icon {
        transform: scale(0.7);
        margin: -12px -8px;
        position: relative;
    }
`;

export const MoreInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
`;

const indicator = css`
    line-height: 14px;
    font-size: 14px;
    text-align: right;
    padding-right: 4px;
    [class^="i-"] {
        font-size: 10px;
    }
    .i-check,
    .i-times {
        font-size: 11px;
    }
`;

export const TotalPlay = styled.div`
    ${indicator}
    color: ${p => p.theme.c.play};
`;

export const TotalFail = styled.div`
    ${indicator}
    color: ${p => p.theme.c.incorrect};
    
    &.FirstCorrect {
        color: ${p => p.theme.c.correct};
        padding-right: 14px;
    }
`;

export const LegendCenter = styled.div`
    text-align: center;
`;

export const Legend = styled.div<ILegendStyleProps>`
    margin: auto;
    padding: 16px;
    display: inline-flex;
    margin-top: 20px;
    box-shadow: 0 0 5px 0 ${p => p.theme.c.blackShadow2};
    background-color: ${p => p.theme.c.snow};
    border-radius: 26px;
    box-sizing: border-box;
    justify-content: space-evenly;

    ${p =>
        (p.studentCompleted ? p.theme.md : p.theme.sm).max(css`
            flex-direction: column;
            align-items: center;
            margin-bottom: 8px;
        `)}
`;

const legendStyle = css`
    color: ${p => p.theme.c.correct};
    font-weight: 700;
    display: flex;
    align-items: center;
    margin-right: 6px;

    [class^="i-"] {
        font-size: 14px;
        margin-left: 4px;
        margin-right: 4px;
    }
    .i-check,
    .i-times {
        font-size: 18px;
        position: relative;
        top: 1px;
    }

    ${p =>
        p.theme.sm.max(css`
            font-size: 14px;
            &.Legend {
                margin-right: 0;
                margin-bottom: 8px;
            }
        `)}

    @media (max-width: 350px) {
        [class^="i-"] {
            display: none;
        }
    }
`;

export const LegendPlayed = styled.div`
    ${legendStyle}
    color: ${p => p.theme.c.play};
`;

export const LegendFailed = styled.div`
    ${legendStyle}
    color: ${p => p.theme.c.incorrect};
    
`;

export const LegendFirstSuccess = styled.div`
    ${legendStyle}
    color: ${p => p.theme.c.correct};
`;

export const LegendGaveUp = styled.div`
    ${legendStyle}
    background-color: ${p => transparentize(0.9, p.theme.c.incorrect)};
    padding: 6px 12px;
    border-radius: 26px;
    color: ${p => p.theme.c.grey9};
`;

export const Difficulty = styled.div`
    position: absolute;
    top: -2px;
    left: 55px;
    width: 24px;
    height: 24px;
    border-radius: 15px;
    box-shadow: 0 0 3px 0 ${p => p.theme.c.blackShadow3};
    color: ${p => p.theme.c.white};
    display: flex;
    align-items: center;
    justify-content: center;

    .i-chevron-right {
        font-size: 17px;
        font-weight: 800;
    }

    &.Hard {
        background-color: ${p => p.theme.c.incorrect};
        .i-chevron-right {
            transform: rotate(-90deg) translateX(1px);
        }
    }
    &.Easy {
        background-color: ${p => p.theme.c.correct};
        .i-chevron-right {
            transform: rotate(90deg) translateX(1px);
        }
    }
`;